import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';

export enum IdleUserTimes {
  IdleTime = 3000,
  CountdownTime = 5000
}

@Injectable({
  providedIn: 'root'
})
export class IdleUserService {
  private timeoutId: any;
  private countdownId: any;
  private countdownValue!: number;
  timeIdle: any;
  timeOut: any;
  userInactive: Subject<boolean> = new Subject();

  constructor(private notifiyService:NotificationService,private router:Router) {
    this.timeIdle = parseFloat(localStorage.getItem('iaTime')!);
    this.timeOut = parseFloat(localStorage.getItem('timeOut')!);
    this.reset();
    this.initListener();

    
  }

  initListener() {
    window.addEventListener('mousemove', () => this.reset());
    window.addEventListener('click', () => this.reset());
    window.addEventListener('keypress', () => this.reset());
    window.addEventListener('DOMMouseScroll', () => this.reset());
    window.addEventListener('mousewheel', () => this.reset());
    window.addEventListener('touchmove', () => this.reset());
    window.addEventListener('MSPointerMove', () => this.reset());
  }

  reset() {
    clearTimeout(this.timeoutId);
    clearTimeout(this.countdownId);
    this.startIdleTimer();
    this.notifiyService.notify({
      status:false,
      seconds:this.timeOut
    });
  }

  startIdleTimer() {
    this.timeoutId = setTimeout(() => {
      this.notifiyService.notify({
        status:true,
        seconds:this.timeOut
      });
      this.startCountdown();
    }, this.timeIdle * 1000);
  }

  startCountdown() {
    this.countdownValue = this.timeOut;
    this.countdownId = setInterval(() => {
      this.countdownValue--;
      
      this.notifiyService.notify({
        status:true,
        seconds:this.countdownValue
      });
      if (this.countdownValue <= 0) {
        clearInterval(this.countdownId);
        
        this.userInactive.next(true);
        localStorage.removeItem('iaTime');
        localStorage.removeItem('timeOut');
        localStorage.removeItem('tokenMovil');
        localStorage.removeItem('data');
        sessionStorage.clear();
        this.router.navigate(['login']);
      }
    }, 1000);
  }
}